import { Box, Select, MenuItem, FormControl, Typography } from "@mui/material";
import {
  getSortNameTranslated,
  SORT_KEYS_BLACKLIST,
} from "../../utils/constants";
import { ISortBarProps } from "../../interfaces/order";

const SortBar = ({
  availableSorts,
  appliedSort,
  handleChangeFilter,
}: ISortBarProps) => {
  if (!availableSorts || availableSorts.length === 0) return null;
  const DEFAULT_SORT = "updated_at_desc";
  const filteredAvailableSorts = (availableSorts || []).filter(
    (opt) => !SORT_KEYS_BLACKLIST.includes(opt) && opt !== appliedSort
  );

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography variant="body2" color="primary" sx={{ whiteSpace: "nowrap" }}>
        Ordenar por:
      </Typography>
      <FormControl
        size="small"
        sx={{
          minWidth: 220,
          "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        }}
      >
        <Select
          value={appliedSort ?? DEFAULT_SORT}
          onChange={(e) =>
            handleChangeFilter &&
            handleChangeFilter("sort", e.target.value || null)
          }
          MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
          sx={{
            "& .MuiSelect-select": { fontSize: 14, py: 0.75 },
          }}
        >
          {/* Current applied sort */}
          {typeof appliedSort === "string" && (
            <MenuItem value={appliedSort}>
              {getSortNameTranslated(appliedSort)}
            </MenuItem>
          )}
          {/* Rest of available sorts (not blacklisted) */}
          {filteredAvailableSorts.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {getSortNameTranslated(opt)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SortBar;
